import { has, isString, isBoolean, isNumber, isArray, reduce } from 'lodash'
import { BaseOutput } from './base-output.model'

export interface GetConsentsListOutput extends BaseOutput {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  ConsentConfiguration: ConsentsConfiguration[]
}

interface ConsentsConfiguration {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  ConsentCode: string
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Required: boolean
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Label: string
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Order: number
}

export const isConsentObject = (obj: unknown): obj is ConsentsConfiguration => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const ConsentCode = 'ConsentCode'
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const Required = 'Required'
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const Label = 'Label'
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const Order = 'Order'

  return (
    has(obj, ConsentCode) &&
    has(obj, Required) &&
    has(obj, Label) &&
    has(obj, Order) &&
    isString(obj[ConsentCode]) &&
    isBoolean(obj[Required]) &&
    isString(obj[Label]) &&
    isNumber(obj[Order])
  )
}

export const isGetConsentsListOutput = (obj: unknown): obj is GetConsentsListOutput => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const ConsentConfiguration = 'ConsentConfiguration'

  return (
    has(obj, ConsentConfiguration) &&
    isArray(obj[ConsentConfiguration]) &&
    reduce(obj[ConsentConfiguration], (acc, value) => isConsentObject(value), false)
  )
}
